import { render, staticRenderFns } from "./VendaAberta.vue?vue&type=template&id=230a67e5&"
import script from "./VendaAberta.vue?vue&type=script&lang=js&"
export * from "./VendaAberta.vue?vue&type=script&lang=js&"
import style0 from "./VendaAberta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports